<template>
  <div class="app-container">
    <div class="app-header">
      <div class="app-title">CG后台管理系统</div>
      <el-menu mode="horizontal" @select="onMenuClick" class="app-menu" background-color="#4489FE" text-color="#FFFFFF" active-text-color="#FFF">
        <template v-for="(menu, i) in menus">
          <el-menu-item :index="menu.address" :key="i" v-if="!menu.children || !menu.children.length">{{menu.name}}</el-menu-item>
          <el-submenu :index="menu.address" :key="i" v-else>
            <template slot="title">{{menu.name}}</template>
            <el-menu-item :index="child.address" v-for="(child, j) in menu.children" :key="i + '-' + j">{{child.name}}</el-menu-item>
          </el-submenu>
        </template>
      </el-menu>
      <div class="app-profile" v-if="logined">
        <el-dropdown @command="onProfileMenuClick">
          <span class="app-username">&nbsp;{{username}}<i class="el-icon-arrow-down el-icon--right"></i></span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="resetPassword">修改密码</el-dropdown-item>
            <el-dropdown-item command="logout" divided>退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <app-tab ref="tab" v-if="logined"></app-tab>
    <div class="app-content">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>

    <el-dialog title="修改密码" :visible.sync="showResetPasswordWindow" @close="resetResetPasswordForm">
      <el-form :model="resetPasswordForm" :rules="resetPasswordFormRule" ref="resetPasswordForm" :status-icon="true">
        <el-form-item label="原登录密码" prop="password">
          <el-input v-model="resetPasswordForm.password" placeholder="请输入原登录密码" type="password" :maxlength="40"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="newPassword">
          <el-input v-model="resetPasswordForm.newPassword" placeholder="请输入新登录密码" type="password" :maxlength="40"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="newPassword2">
          <el-input v-model="resetPasswordForm.newPassword2" placeholder="请再次输入新登录密码" type="password" :maxlength="40"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showResetPasswordWindow = false">取 消</el-button>
        <el-button type="primary" @click="resetPassword">修改密码</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="confirmParam.title" :visible.sync="showConfirm" width="30%">
      <span>{{confirmParam.msg}}</span>
      <span slot="footer">
        <el-button @click="onConfirm(false)">取 消</el-button>
        <el-button @click="onConfirm(true)" type="primary">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import md5 from 'js-md5'
import { web } from './config'
import AppTab from '@/components/AppTab'

export default {
  name: 'app',
  components: {
    AppTab
  },
  data () {
    return {
      logined: false,
      username: '',
      menus: [],
      showResetPasswordWindow: false,
      resetPasswordForm: {
        password: '',
        newPassword: '',
        newPassword2: ''
      },
      resetPasswordFormRule: {
        password: [{ required: true, message: '请输入原登录密码', trigger: 'blur' }],
        newPassword: [{ required: true, message: '请输入新登录密码', trigger: 'blur' }],
        newPassword2: [{
          trigger: 'blur',
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('请再次输入新登录密码'))
            } else if (value !== this.resetPasswordForm.newPassword) {
              callback(new Error('两次输入密码不一致!'))
            } else {
              callback()
            }
          }
        }]
      },
      showConfirm: false,
      confirmParam: {}
    }
  },
  created () {
    this.init()
    this.bindGlobalEvent()
  },
  methods: {
    init () {
      this.logined = !!this.$store.state.admin.adminId
      this.username = this.$store.state.admin.username
      this.menus = this.$store.state.admin.menus
    },
    onMenuClick (path) {
      this.$refs.tab.open(path)
    },
    onProfileMenuClick (command) {
      if (command === 'resetPassword') {
        this.openResetPasswordWindow()
      } else if (command === 'logout') {
        this.logout()
      }
    },
    openResetPasswordWindow () {
      this.showResetPasswordWindow = true
      this.$nextTick(() => {
        this.$refs.resetPasswordForm.fields[0].$children[0].focus()
      })
    },
    resetPassword () {
      this.$refs.resetPasswordForm.validate((success) => {
        if (success) {
          this.$http.request({
            method: 'put',
            url: '/api/cgAdmins/password',
            data: JSON.stringify({
              password: md5(this.resetPasswordForm.password),
              newPassword: md5(this.resetPasswordForm.newPassword),
              newPassword2: md5(this.resetPasswordForm.newPassword2)
            })
          }).then(() => {
            this.showResetPasswordWindow = false
          })
        } else {
          return false
        }
      })
    },
    resetResetPasswordForm () {
      this.$refs.resetPasswordForm.resetFields()
    },
    logout () {
      this.$http.request({
        method: 'post',
        url: '/api/cgAdmins/logout',
      }).then(() => {
        sessionStorage.removeItem('admin')
        location.href = web
      })
    },
    bindGlobalEvent () {
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'confirm') {
          this.confirmParam = state.confirm
          this.showConfirm = !!state.confirm && !!state.confirm.title
        }
      })
    },
    onConfirm (result) {
      this.showConfirm = false
      this.confirmParam.callback.apply(this.confirmParam.scope || null, [result, this.confirmParam.data])
    }
  }
}
</script>

<style>
.app-container{width:100%;}
.app-header{background-color:#4489FE;height:60px;line-height:60px;}
.app-title{float:left;height:100%;color:#fff;margin:0 20px;font-size:18px;}
.app-menu{float:left;border-bottom:none;}
.app-menu>.el-menu-item{border-bottom:none;font-size:0.875rem;}
.app-menu>.el-menu-item.is-active{border-bottom:none;background-color:#4489FE !important;}
.app-menu>.el-submenu.is-active>.el-submenu__title{border-bottom:none;background-color:#4489FE !important;}
.app-menu>.el-submenu>.el-submenu__title>i{color:#fff;}
.app-profile{float:right;margin:0 20px;}
.app-username{color:#FFF;}
.app-content{min-height:600px;margin:0 8px 40px 8px;border:1px solid #e4e7ed;border-top:0;box-sizing:border-box;}
.app-toolbar{width:100%;box-sizing:border-box;padding:10px 10px 0;}
.app-toolbar1{width:100%;box-sizing:border-box;padding:12px 10px;border-bottom:1px solid #e4e7ed}
.app-toolbar>button,.app-toolbar1>button{float:right;margin-left:16px;}
.app-toolbar:after,.app-toolbar1:after,.app-toolbar2:after{content:".";display:block;height:0;clear:both;visibility:hidden}
.app-toolbar>label,.app-toolbar1>label{color:#606266;font-size:14px;margin:0 10px;}
.app-toolbar2{width:100%;box-sizing:border-box;padding:12px 10px;border-bottom:1px solid #e4e7ed}
.app-toolbar2>.el-input-group{float:right;}

.el-form>.el-form-item:last-child{margin-bottom:0;}
.app-pagination{text-align:right;margin:16px 0 0;}
</style>
